"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Browser = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Browser = function (_a) {
    var id = _a.id;
    var clipPathId = id ? "Browser__clip0__".concat(id) : 'Browser__clip0';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#".concat(clipPathId, ")") },
            react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M2.4 2H21.6C22.9255 2 24 3.07452 24 4.4V18.8C24 20.1255 22.9255 21.2 21.6 21.2H2.4C1.07452 21.2 0 20.1255 0 18.8V4.4C0 3.07452 1.07452 2 2.4 2ZM21.6 18.8V6.79999H2.40001V18.8H21.6Z" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: clipPathId },
                react_1.default.createElement("rect", { width: "24", height: "24", fill: "currentColor" })))));
};
exports.Browser = Browser;
//# sourceMappingURL=browser.js.map